export default "__VITE_ASSET__DkCtKqIT__"